import { useEffect, useState } from 'react';

import { supabase } from '../supabase';
import { tourDetailColumns, type Tour } from '../tours';

// Mirrors use-event.ts: single tour by id from the tours table.
export function useTour(id: string | undefined) {
  const [tour, setTour] = useState<Tour | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    supabase
      .from('tours')
      .select(tourDetailColumns())
      .eq('id', id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          setError(error.message);
          setTour(null);
        } else {
          setTour((data ?? null) as Tour | null);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { tour, loading, error };
}
